export enum EventStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Completed = 'COMPLETED',
}
